import { Copy } from "lucide-react";

export type DuplicateKind = "existing" | "repeat";

const LABELS: Record<DuplicateKind, string> = {
  // Staged line that matches one already saved on this offer
  existing: "Already exists in the list",
  // Staged line that repeats an earlier row in the same staging list
  repeat: "Duplicate in CSV",
};

const TITLES: Record<DuplicateKind, string> = {
  existing: "This line is already saved on this offer",
  repeat: "This line appears earlier in the staged list",
};

/**
 * Marks a staged line as a duplicate. Creation is blocked while any of these
 * are showing, so the operator resolves them before saving.
 */
export default function DuplicateBadge({ kind }: { kind: DuplicateKind }) {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-700"
      title={TITLES[kind]}
    >
      <Copy className="h-3 w-3" />
      {LABELS[kind]}
    </span>
  );
}
